import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/ProductsSubpages.css';
import em from '../styling/images/manualregulator/electromaster/category1a.png';
import va from '../styling/images/manualregulator/variac/category2a.png';

const ManualRegulator = () => {
  const categories = [
    { 
      id: 1, 
      name: 'ELECTROMASTER SERIES',
      images: [
        { id: 1, src: em, caption1: 'ElectroMaster', caption2: '3KVA to 20KVA' }
      ]
    },{
      id: 2,
      name: 'VARIAC',
      images: [
        { id: 2, src: va, caption1: 'Variac', caption2: '0.5KVA to 10KVA' }
      ]
    }
  ];

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <nav className="side-nav">
        <ul>
          {categories.map(category => (
            <li key={category.id}>
              <button onClick={() => scrollToHeading(`heading-${category.id}`)}>{category.name}</button>
              <ul>
                {category.images.map(image => (
                  <li key={image.id}>
                    <Link to={`/product_items/ManualRegulator_cat/ManualRegulatorSubpages/${image.id}`}>
                      {image.caption1}  {image.caption2}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
      <div className="content">
        <h1>MANUAL REGULATOR</h1>
        {categories.map(category => (
          <div key={category.id} id={`heading-${category.id}`}>
            <h2>{category.name}</h2>
            <div className='row'>
              {category.images.map(image => (
                <div key={image.id} className='category-products'>
                  <Link to={`/product_items/ManualRegulator_cat/ManualRegulatorSubpages/${image.id}`} state={{ productCategory: category.name, productCap1: image.caption1, productCap2: image.caption2}}>
                    <img src={image.src} alt={`Image ${image.id}`} className='category-images'/>
                  </Link>
                  <p>{image.caption1}<br/>{image.caption2}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManualRegulator;
